import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { Link, Page } from '../../components';
import { UserContext } from '../../context';

export const NotFound = () => {
  const { user, isLoading } = useContext(UserContext);
  if (isLoading) {
    return null;
  }
  if (user && user?.userName) {
    return (
      <Page title="404 Page Not Found">
        <Stack justifyContent="center" alignItems="center" gap={1} height="35rem">
          <Typography component="h1" variant="h3">
            404 Page Not Found
          </Typography>
          <Link to="/">Back to Home</Link>
        </Stack>
      </Page>
    );
  }
  return (
    <Stack justifyContent="center" alignItems="center" gap={1} height="35rem">
      <Typography component="h1" variant="h3">
        404 Page Not Found
      </Typography>
      <Link to="/">Back to Home</Link>
    </Stack>
  );
};
